export default "__VITE_ASSET__Bm78TItB__"